import React from 'react'
import { useRecordContext, Toolbar, DeleteButton } from 'react-admin'
import { Stack } from '@mui/material'
import { BackButton, SaveWithConfirmButton, UnpublishButton } from '../buttons/index'
import { saveAndPublishToolBarType } from './type'
import PublishAndSaveButton from '../buttons/PublishAndSaveButton'
const SaveAndPublishToolBar: React.FC<saveAndPublishToolBarType> = ({
  children = null,
  encType,
  leftButtons,
  rightButtons,
}) => {
  const record = useRecordContext()
  const { is_published: isPublished } = record || {
    is_published: false,
  }
  const released = isPublished
  return (
    <Toolbar sx={{ justifyContent: 'space-between', py: 1.5 }}>
      <Stack flexGrow={1} spacing={1}>
        <Stack direction='row' justifyContent='space-between'>
          <Stack direction='row' gap={2}>
            {record ? <DeleteButton size='medium' /> : <BackButton />}
            {leftButtons}
          </Stack>
          <Stack direction='row' justifyContent='space-between' gap={2}>
            {rightButtons}
            {(!released || !record) && (
              <>
                <SaveWithConfirmButton encType={encType} alwaysEnable={true} />
                <PublishAndSaveButton encType={encType} />
              </>
            )}
            {record && released && (
              <>
                <UnpublishButton encType={encType} />
                <SaveWithConfirmButton encType={encType} />
              </>
            )}
          </Stack>
        </Stack>
        {children}
      </Stack>
    </Toolbar>
  )
}

export default SaveAndPublishToolBar
